"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const _1 = require("./");
class PaginatedListShelf {
    constructor(getItems, fetchOptions) {
        this.loader = new _1.LoaderShelf();
        this.initialLoader = new _1.InitialLoaderShelf();
        this.page = 0;
        this.itemsPerPage = 20;
        this.items = [];
        this.error = null;
        this.hasNextPage = false;
        this.fetchPage = (page) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (page < 0) {
                return;
            }
            try {
                this.loader.tryStart("Cannot fetch again. The last fetch still loading.");
                const newItems = yield this.getItems(page);
                this.afterFetch(newItems, page);
                if (this._onAfterFetch) {
                    this._onAfterFetch(newItems);
                }
            }
            catch (e) {
                this.setError(e);
                if (this._onFetchError) {
                    this._onFetchError(e);
                }
            }
            finally {
                this.initialLoader.done();
                this.loader.end();
            }
            if (this._onFinishFetch) {
                this._onFinishFetch();
            }
        });
        this.afterFetch = (newItems, page) => {
            this.hasNextPage = newItems.length === this.itemsPerPage;
            this.items = newItems;
            this.page = page;
        };
        this.refresh = () => {
            this.fetchPage(this.page);
        };
        this.clear = () => {
            this.items = [];
            this.error = null;
        };
        this.setError = (error) => {
            this.error = error.message || "error";
        };
        this.nextPage = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield this.fetchPage(this.page + 1); });
        this.previousPage = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield this.fetchPage(this.page - 1); });
        this.getItems = getItems;
        if (fetchOptions) {
            if (fetchOptions.itemsPerPage) {
                this.itemsPerPage = fetchOptions.itemsPerPage;
            }
            this._onAfterFetch = fetchOptions.onAfterFetch;
            this._onFetchError = fetchOptions.onFetchError;
            this._onFinishFetch = fetchOptions.onFinishFetch;
        }
        mobx_1.makeAutoObservable(this);
        if (fetchOptions && fetchOptions.fetchOnConstructor) {
            this.fetchPage(0);
        }
    }
}
exports.default = PaginatedListShelf;
